import React from 'react';
import { connect } from 'react-redux';
import { Breadcrumb } from 'enlm_ui_common';
import { forwardTo } from '../../../utils/helper';
import history from '../../../routes/history';
import { setShowHidePage } from '../../../containers/Layouts/actions';

const Breadcrumbs = props => {
  return (
    <Breadcrumb
      einOptIn={props.einOptIn}
      countryCode={props.countryCode}
      companyId={props.companyId}
      companyInfo={props.companyInfo}
      featureList={props.featureList}
      accountData={props.accountDetail}
      viewOnlyAccess={props.viewOnlyAccess}
      locale={props.locale}
      showPage={props.showPage}
      setShowHidePage={props.setShowHidePage}
      forwardTo={forwardTo}
      matchProps={props.matchProps}
      history={history}
      fromITK={props.fromITK}
    />);
};

const mapStateToProps = state => ({
  einOptIn: state.appReducer.einOptIn,
  countryCode: state.appReducer.countryCode,
  companyId: state.appReducer.companyId,
  companyInfo: state.appReducer.companyInfo,
  featureList: state.appReducer.featureList,
  accountData: state.accountReducer.accountDetail,
  viewOnlyAccess: state.accountReducer.viewOnlyAccess,
  locale: state.accountReducer.locale,
  showPage: state.appReducer.showPage
});

const mapDispatchToProps = dispatch => ({
  setShowHidePage: (showPage) => dispatch(setShowHidePage(showPage))
});

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
